import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { NotificationsMenuComponent } from '@lc/ui/lib/layout/toolbar/notifications-menu/notifications-menu.component';
import { RouterLink } from '@angular/router';
import { BspkAvatar } from '@bspk/ngx-ui/lib/avatar/avatar.component';
import { BspkDivider, BspkIcon, BspkListItem, BspkTxt } from '@bspk/ngx-ui';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { AppService, BrandService } from '@lc/core';
import { E2eIdDirective } from '@lc/ui';
import { NgClass } from '@angular/common';

export interface MenuItem {
  name: string;
  icon: string;
  url?: string;
  onClick?: () => void;
}

@Component({
  selector: 'lc-appbar',
  templateUrl: './appbar.component.html',
  styleUrl: './appbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NotificationsMenuComponent,
    RouterLink,
    BspkAvatar,
    BspkIcon,
    MatMenuTrigger,
    MatMenu,
    BspkDivider,
    BspkListItem,
    BspkTxt,
    E2eIdDirective,
    NgClass,
  ],
})
export class AppbarComponent {
  readonly menuItems = input.required<MenuItem[]>();
  readonly firstName = input.required<string>();
  readonly fullName = input.required<string>();
  readonly profilePhoto = input<string>();
  readonly brand = input<string>();
  readonly isMobile: Signal<boolean>;
  readonly brandService = inject(BrandService);
  readonly logo = this.brandService.brandLogo;
  readonly isCompassHeader = computed(() => AppService.isListingConciergeProduct
    && this.brandService.brandCode() === 'CMP' && !this.brandService.isTheStudio());

  constructor() {
    const breakpointObserver = inject(BreakpointObserver);
    this.isMobile = toSignal(
      breakpointObserver.observe(['(min-width: 960px)']).pipe(map((state) => !state.matches)),
    );
  }
}
